import React from 'react';
import { Bar, Pie, PieTabled } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const TableSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Bar
                        title={t("Costs by Area")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_area_name/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>

                <Box className="report-item">
                    <Bar
                        title={t("Costs by Source Type")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_source_type/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>

                <Box className="report-item">
                    <Bar
                        title={t("Costs by Source")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_source_name/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>
                
            </Box>
            
        </Box>
    )
}

export default TableSet;